export { default } from './CCPA';
